import { html } from "lit-html";

export default html`<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	height="24"
	width="24"
>
	<g>
		<path
			d="M23,18.5a1,1,0,0,0-1,1v2.25a.25.25,0,0,1-.25.25H19.5a1,1,0,0,0,0,2H22a2,2,0,0,0,2-2V19.5A1,1,0,0,0,23,18.5Z"
		></path>
		<path
			d="M22,0H19.5a1,1,0,0,0,0,2h2.25a.25.25,0,0,1,.25.25V4.5a1,1,0,0,0,2,0V2A2,2,0,0,0,22,0Z"
		></path>
		<path
			d="M4.5,0H2A2,2,0,0,0,0,2V4.5a1,1,0,0,0,2,0V2.25A.25.25,0,0,1,2.25,2H4.5a1,1,0,0,0,0-2Z"
		></path>
		<path
			d="M4.5,22H2.25A.25.25,0,0,1,2,21.75V19.5a1,1,0,0,0-2,0V22a2,2,0,0,0,2,2H4.5a1,1,0,0,0,0-2Z"
		></path>
		<path
			d="M23,8a1,1,0,0,0-1,1v1.75a.25.25,0,0,1-.25.25H19.5a1,1,0,0,0,0,2H22v2a1,1,0,0,0,2,0V9A1,1,0,0,0,23,8Z"
		></path>
		<path
			d="M15,11H13.25a.25.25,0,0,1-.25-.25V9a1,1,0,0,0-2,0v1.75a.25.25,0,0,1-.25.25H9a1,1,0,0,0,0,2h1.75a.25.25,0,0,1,.25.25V15a1,1,0,0,0,2,0V13.25a.25.25,0,0,1,.25-.25H15a1,1,0,0,0,0-2Z"
		></path>
		<path
			d="M15,22H13.25a.25.25,0,0,1-.25-.25V19.5a1,1,0,0,0-2,0v2.25a.25.25,0,0,1-.25.25H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"
		></path>
		<path
			d="M15,0H9A1,1,0,0,0,9,2h1.75a.25.25,0,0,1,.25.25V4.5a1,1,0,0,0,2,0V2.25A.25.25,0,0,1,13.25,2H15a1,1,0,0,0,0-2Z"
		></path>
		<path
			d="M4.5,11H2.25A.25.25,0,0,1,2,10.75V9A1,1,0,0,0,0,9v6a1,1,0,0,0,2,0V13.25A.25.25,0,0,1,2.25,13H4.5a1,1,0,0,0,0-2Z"
		></path>
	</g>
</svg>`.strings.join("");
